import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import LegalPageLayout from "./LegalPageLayout";

const content = {
  fr: {
    title: "Conditions Générales d'Utilisation",
    sections: [
      {
        title: "Présentation",
        text: "LëtzServices est une plateforme de mise en relation entre particuliers au Luxembourg pour les services et la vente d'objets. L'utilisation du site implique l'acceptation des présentes CGU.",
      },
      {
        title: "Inscription",
        items: [
          "L'inscription est gratuite et réservée aux personnes majeures",
          "Vous devez fournir des informations exactes",
          "Un seul compte par personne est autorisé",
          "Vous êtes responsable de la confidentialité de vos identifiants",
        ],
      },
      {
        title: "Utilisation du service",
        intro: "Il est interdit de :",
        items: [
          "Publier du contenu illégal, offensant ou trompeur",
          "Usurper l'identité d'un tiers",
          "Utiliser le service à des fins commerciales non autorisées",
          "Collecter les données d'autres utilisateurs",
          "Perturber le fonctionnement du site",
        ],
      },
      {
        title: "Contenu utilisateur",
        text: "Vous restez propriétaire du contenu que vous publiez. En publiant sur LëtzServices, vous nous accordez une licence non-exclusive pour afficher ce contenu sur la plateforme.",
      },
      {
        title: "Responsabilité",
        text: "LëtzServices ne peut être tenu responsable du contenu publié par les utilisateurs, des transactions entre utilisateurs, ou des dommages indirects liés à l'utilisation du service.",
      },
      {
        title: "Modération",
        text: "Nous nous réservons le droit de supprimer tout contenu non conforme et de suspendre les comptes en infraction, sans préavis ni indemnité.",
      },
      {
        title: "Propriété intellectuelle",
        text: "Le nom LëtzServices, le logo et l'ensemble des éléments graphiques du site sont notre propriété exclusive. Toute reproduction est interdite sans autorisation.",
      },
      {
        title: "Droit applicable",
        text: "Les présentes CGU sont soumises au droit luxembourgeois. En cas de litige, les tribunaux du Luxembourg seront compétents.",
      },
      {
        title: "Contact",
        text: "Pour toute question : letzservicesinfo@gmail.com",
      },
    ],
  },
  en: {
    title: "Terms of Use",
    sections: [
      {
        title: "Introduction",
        text: "LëtzServices is a platform connecting individuals in Luxembourg for services and selling items. Using the site implies acceptance of these Terms of Use.",
      },
      {
        title: "Registration",
        items: [
          "Registration is free and reserved for adults",
          "You must provide accurate information",
          "Only one account per person is allowed",
          "You are responsible for the confidentiality of your credentials",
        ],
      },
      {
        title: "Use of Service",
        intro: "It is forbidden to:",
        items: [
          "Publish illegal, offensive or misleading content",
          "Impersonate another person",
          "Use the service for unauthorized commercial purposes",
          "Collect data from other users",
          "Disrupt the operation of the site",
        ],
      },
      {
        title: "User Content",
        text: "You remain the owner of the content you publish. By publishing on LëtzServices, you grant us a non-exclusive license to display this content on the platform.",
      },
      {
        title: "Liability",
        text: "LëtzServices cannot be held responsible for content published by users, transactions between users, or indirect damages related to the use of the service.",
      },
      {
        title: "Moderation",
        text: "We reserve the right to remove any non-compliant content and suspend accounts in violation, without notice or compensation.",
      },
      {
        title: "Intellectual Property",
        text: "The name LëtzServices, the logo and all graphic elements of the site are our exclusive property. Any reproduction is prohibited without authorization.",
      },
      {
        title: "Applicable Law",
        text: "These Terms of Use are governed by Luxembourg law. In case of dispute, the courts of Luxembourg shall have jurisdiction.",
      },
      {
        title: "Contact",
        text: "For any questions: letzservicesinfo@gmail.com",
      },
    ],
  },
};

const TermsOfUsePage = () => {
  const { lang } = useLanguage();
  return <LegalPageLayout content={content[lang] || content.fr} />;
};

export default TermsOfUsePage;
